import { Component, Input } from '@angular/core';
import { EstadisticoWidget } from 'src/app/interfaces/widgets/estadistico';

@Component({
	selector: 'app-widget-estadistico',
	templateUrl: './widget-estadistico.component.html',
	styleUrls: ['./widget-estadistico.component.scss']
})
export class WidgetEstadisticoComponent {
	@Input() data!: EstadisticoWidget;

}
